import React from 'react';
import Container from 'Nori/Container';
import styles from 'Custom/Carousel/CarouselNavigation.module.scss';

const CarouselNavigation = ({
  items = [],
  onMove = () => {},
  activeItem = 0,
  offset = 0,
  className = '',
  ...props
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <div className={`${styles.carouselNavigation} ${className}`} {...props}>
      <ul className={styles.navigationList}>
        {items.map((item, index) => (
          <li
            key={`carousel-navigation-item-${index}`}
            className={`${index === activeItem ? styles.active : ''}`}
            onClick={() => onMove(index + offset)}
            data-design-type="clickAction"
            data-design-category="content_tabs_vd"
            data-design-action="Button-Number"
            data-design-label={index + 1}
            data-design-nori_id="Carousel"
            data-design-module_name="GET TO KNOW NEXPLANON"
            data-design-module_no="01"
          >
            <button
              data-design-type="clickAction"
              data-design-category="content_tabs_vd"
              data-design-action="Button-Number"
              data-design-label={index + 1}
              data-design-nori_id="Carousel"
              data-design-module_name="GET TO KNOW NEXPLANON"
              data-design-module_no="01"
              className={styles.navigationIndex}
            >
              {index + 1}
            </button>
            <h4 className={styles.navigationTitle}>{item.navigationTitle}</h4>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CarouselNavigation;
